<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">
      Recently Accepted<span class="sub-title"> - Past 30 days</span>
    </h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
      [smallSize]="true"
    ></item-picker>
  </div>
  @if (loaded) {
    <div>
      @if (odataResult.length > 0) {
        <div class="items-container">
          <ng-scrollbar>
            @for (item of odataResult; track item) {
              <app-recent-accepts-item
                [item]="item"
                [workspaces]="workspaces"
                [activeWorkspaceIsOrg]="activeWorkspaceIsOrg"
              ></app-recent-accepts-item>
            }
          </ng-scrollbar>
        </div>
      }
      @if (odataResult.length == 0) {
        <div class="no-content" fxLayout="column" fxLayoutAlign="center center">
          <p class="m-0">
            No one has accepted any invitations in the past 30 days.
          </p>
          <p>
            You have invited {{ invitedPeopleCount }} people in the past 30 days
          </p>
          <a
            mat-flat-button
            color="primary"
            href="https://support.lineupteams.com/hc/en-us/articles/4446812515863"
            >Learn About Reminders</a
          >
        </div>
      }
    </div>
  }
  @if (!loaded) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
</div>
